import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTopicDetailOverView, getTopicOverview } from '@/services/kopTopicService';
import { getKopClusterResources } from '@/services/permissionsService';

const initialState = {
  overview: {},
  loading: false,
  tenantOptions: [],
  detailOverview: {},
};

export const fetchTopicOverview = createAsyncThunk(
  'kopTopic/fetchNamespaceOverview',
  async (clusterName) => {
    const response = await getTopicOverview(clusterName);
    return response.data;
  },
);

export const fetchTenantOptions = createAsyncThunk(
  'kopTopic/fetchTenantOptions',
  async (params) => {
    const response = await getKopClusterResources(params);
    return response.data;
  },
);

// 单个topic 总览数据
export const fetchTopicDetailOverview = createAsyncThunk(
  'topic/fetchTopicDetailOverview',
  async (params) => {
    const response = await getTopicDetailOverView(params);
    return response.data;
  },
);

export const kopTopicSlice = createSlice({
  name: 'kopTopic',
  initialState,
  reducers: {
    resetDetail: (state) => {
      state.detailOverview = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopicOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTopicOverview.fulfilled, (state, action) => {
        state.overview = action.payload;
        state.loading = false;
      })
      .addCase(fetchTopicOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchTenantOptions.fulfilled, (state, action) => {
        state.tenantOptions = action.payload.map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchTopicDetailOverview.pending, (state) => {
        state.detailOverview = {};
        state.loading = true;
      })
      .addCase(fetchTopicDetailOverview.fulfilled, (state, action) => {
        state.detailOverview = action.payload || {};
        state.loading = false;
      })
      .addCase(fetchTopicDetailOverview.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default kopTopicSlice.reducer;

export const { resetDetail } = kopTopicSlice.actions;
